import React from 'react';
import { Link } from 'react-router-dom';
import './Code.css';

const Code = () => {
  return (
    <div className="code-page">
      <section className="code-hero">
        <div className="container">
          <div className="hero-content-code">
            <h1 className="code-title">Code de la Route</h1>
            <p className="code-subtitle">En Ligne</p>
            <p className="hero-description-code">
              Maîtrisez le code de la route à votre rythme grâce à notre plateforme en ligne. 
              Accédez à des milliers de questions pratiques et des examens blancs pour vous préparer 
              efficacement et obtenir votre code dès la première fois.
            </p>
          </div>
        </div>
      </section>

      <section className="code-content">
        <div className="container">
          <div className="code-intro">
            <h2 className="code-intro-title">Apprenez le code à tout moment, depuis n'importe où !</h2>
            <div className="code-intro-text">
              <p>
                Bénéficiez d'une préparation complète et flexible pour réussir votre examen du code de la route.
              </p>
              <p>
                Accédez à <strong>PrepaCode</strong> qui vous propose une base de données exhaustive avec 
                plus de <strong>6700 questions</strong> couvrant l'ensemble du programme, vous permettant ainsi 
                de vous entraîner efficacement et d'atteindre vos objectifs.
              </p>
              <p>
                Mettez-vous dans les conditions d'examen grâce à nos simulations d'épreuves blanches, 
                idéales pour vous rassurer avant le véritable passage.
              </p>
            </div>
            <Link to="/contact" className="btn btn-orange code-cta">
              Code en Ligne
            </Link>
          </div>

          <div className="code-documents">
            <h2 className="documents-title">Constitution du Dossier</h2>
            <div className="documents-info">
              <p className="documents-subtitle">Photocopie ou Mail :</p>
              <a href="mailto:topconduite.mitry@gmail.com" className="documents-email">
                topconduite.mitry@gmail.com
              </a>
            </div>

            <div className="documents-list">
              <h3 className="documents-list-title">Documents nécessaires :</h3>
              <ul className="documents-items">
                <li>4 photos d'identité ANTS</li>
                <li>2 enveloppes A5 (lettre suivie sans adresse)</li>
                <li>1 pièce d'identité recto-verso</li>
                <li>1 pièce d'identité du représentant légal (si élève mineur)</li>
                <li>1 justificatif de domicile de -6 mois (si hébergé : attestation d'hébergement manuscrite + pièce d'identité de l'hébergeant)</li>
                <li>ASSR2 : âgé entre 15 et 25 ans</li>
                <li>JDC : âgé entre 17 et 25 ans</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Code;
